import axios from 'axios';
import apiConfig from '../../api.config';
import { gzipSync } from 'fflate';

export default async function processPMSConfigFile(file, pmsId) {
  const {
    host,
    URIs: { pmsConfigFile },
  } = apiConfig;

  const uri = `${host}${pmsConfigFile}`.replace(':pmsId', pmsId);

  const buffer = await file.arrayBuffer();
  const compressed = gzipSync(new Uint8Array(buffer));

  const compressedFile = new File([compressed], `${file.name}.gz`, {
    type: 'application/gzip',
  });

  const formData = new FormData();
  formData.append('file', compressedFile);

  try {
    const response = await axios.post(uri, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}
